import React, { useState, useEffect } from "react";
import get from "lodash/get";
// import groupBy from "lodash/groupBy";
import mapboxgl from "mapbox-gl";
import { getLocationsList } from "../../config/api/locations";

// import ListView from "../ListView";
// import MarketListView from "../MarketListView";
import MapView from "../MapView";

mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const AppContainer = () => {
  const [isLoading, setLoading] = useState(true);
  // const [market, setMarket] = useState(null);
  // const [markets, setMarkets] = useState([]);
  // const [city, setCity] = useState(null);
  // const [cities, setCities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState(false);

  const fetchLocations = async () => {
    try {
      const resp = await getLocationsList();
      const offsetResp = await getLocationsList(100);
      const status = get(resp, "status");
      const offsetStatus = get(offsetResp, "status");
      if (status && offsetStatus) {
        const data = [...resp.data, ...offsetResp.data];
        // const marketData = groupBy(data, "acf.market");
        // const marketList = Object.keys(marketData).sort((a, b) =>
        //   a === b ? 0 : a < b ? -1 : 1
        // );
        // setMarkets(marketList);

        // const citiesData = groupBy(data, "acf.city");
        // const citiesList = Object.keys(citiesData).sort((a, b) =>
        //   a === b ? 0 : a < b ? -1 : 1
        // );

        // setCities(citiesList);

        setLocations([...data]);
      } else {
        // setMarkets([]);
        // setCities([]);
        setLocations([]);
      }
    } catch (error) {
      console.log(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLocations();
  }, []);

  // const handleMarketChange = (market) => {
  //   const filterData = locations.filter((data) => data.acf.market === market);
  //   const citiesData = groupBy(filterData, "acf.city");
  //   const citiesList = Object.keys(citiesData).sort((a, b) =>
  //     a === b ? 0 : a < b ? -1 : 1
  //   );
  //   setCities(citiesList);
  //   setMarket(market);
  // };

  if (isLoading) {
    return (
      <div className="container">
        <div className="row py-4 d-flex justify-content-center align-items-center">
          <h2 className="text-white">
            Please wait while we are fetching locations...
          </h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <div className="row py-4 d-flex justify-content-center align-items-center">
          <h2 className="text-white">Error: Something went wrong..</h2>
        </div>
      </div>
    );
  }
  return (
    <div className="container">
      <div className="row py-4">
        {/* {!market ? (
          <MarketListView
            handleMarketChange={handleMarketChange}
            markets={markets}
          />
        ) : !city ? (
          <ListView
            setCity={setCity}
            cities={cities}
            market={market}
            setMarket={setMarket}
          />
        ) : (
          <MapView
            locations={locations}
            city={city}
            setCity={setCity}
            market={market}
          />
        )} */}
        <MapView
          locations={locations}
          // city={city}
          // setCity={setCity}
          // market={market}
        />
      </div>
    </div>
  );
};

export default AppContainer;
